<div class="sidebar-filters-content collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header">
        <button class="row collapse-title btn p-0 dropdown-icon-fix"
                (click)="isCollapsed = !isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="collapseExample"
                data-toggle="collapse"
                role="button">
          <h6>{{'FLEXIBLE_FIXED_BENEFITS.FILTER.CATEGORIES_TYPE' | translate}}</h6>
        </button>
      </div>

      <div [ngbCollapse]="isCollapsed" id="collapseExample">
        <div class="card">
          <div class="card-body">
            <div class="categories-list">
              <div class="category-item" *ngFor="let category of categoryTree">
                <!-- Single item -->
                <div class="filter-check" *ngIf="!(category.children.length > 0)">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="categorySelection[category.id]" [id]="'checkbox-' + category.id"  (change)="checkCategory()"/>
                    <label class="custom-control-label" [for]="'checkbox-' + category.id"></label>
                  </div>
                  <label [for]="'checkbox-' + category.id" class="filter-details">
                    <div class="title" placement="auto"
                         ngbTooltip="{{category.name}}">
                      {{ category.name }}
                    </div>
                  </label>
                </div>

                <!-- Has children -->
                <app-parent-category class="category-item" [category]="category" [categorySelection]="categorySelection" (checkCategory)="checkCategory()"  *ngIf="category.children.length > 0"></app-parent-category>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
